/**
 * @file http 请求对象
 * @author svon.me@gmail.com
 */

import "./config";
import {API} from "@js-lion/api";
import type {AxiosRequestConfig} from "axios";

const http = {
  get: function (url: string, params = {}, config: AxiosRequestConfig = {}) {
    const api = new API();
    if (config.params) {
      const query = {...params, ...config.params};
      return api.get(url, {...config, params: query});
    } else {
      return api.get(url, {params, ...config});
    }
  },
  post: function (url: string, data = {}, config: AxiosRequestConfig = {}) {
    const api = new API();
    return api.post(url, data, config);
  },
  put: function (url: string, data = {}, config: AxiosRequestConfig = {}) {
    const api = new API();
    return api.put(url, data, config);
  },
  patch: function (url: string, data = {}, config: AxiosRequestConfig = {}) {
    const api = new API();
    return api.patch(url, data, config);
  },
  delete: function (url: string, data = {}, config: AxiosRequestConfig = {}) {
    const api = new API();
    return api.delete(url, {data, ...config});
  },
};

export default http;